import { CatalogueIcon } from 'core/components/Icons'
import { Column, Table } from 'core/components/ui/Table'
import React from 'react'
import { EntityVolumeRow } from '../../../domain/entities/SalesReport'
import { SectionCard } from './SectionCard'
import { PAIRED_TABLE_BODY_HEIGHT, formatMT } from './format'

interface InventoryStatusTableProps {
  rows: EntityVolumeRow[]
  loading?: boolean
}

export const InventoryStatusTable: React.FC<InventoryStatusTableProps> = ({ rows, loading = false }) => {
  const columns: Column<EntityVolumeRow>[] = [
    {
      key: 'entityName',
      label: 'Outlets',
      render: (row) => (
        <span className={row.isTotal ? 'font-extrabold text-text-primary' : 'font-semibold text-text-primary'}>
          {row.entityName}
        </span>
      ),
    },
    {
      key: 'units',
      label: 'No. of Units',
      render: (row) => (
        <span className={row.isTotal ? 'font-extrabold text-text-primary' : 'text-text-primary'}>{row.units}</span>
      ),
    },
    {
      key: 'mt',
      label: 'MT',
      render: (row) => (
        <span className={row.isTotal ? 'font-extrabold text-text-primary' : 'text-text-primary'}>
          {formatMT(row.mt)}
        </span>
      ),
    },
  ]

  return (
    <SectionCard title="Current Inventory Status" subtitle="Stock on hand across outlets (FPO, VLCC, Retailers)">
      <Table
        columns={columns}
        data={rows}
        loading={loading}
        emptyMessage="No inventory records."
        emptyIcon={<CatalogueIcon size={20} className="opacity-60" />}
        bodyHeight={PAIRED_TABLE_BODY_HEIGHT}
        stickyLastRow
      />
    </SectionCard>
  )
}
